import { useQuery } from 'react-query';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';
import { useContext } from 'react';

const fetchLicenses = async (token) => {
  const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/licenses`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

const useLicenses = () => {
  const { token } = useContext(AuthContext);

  return useQuery(['licenses'], () => fetchLicenses(token), {
    enabled: !!token, 
  });
};

export default useLicenses;
